import * as serviceContext from './serviceContext';
import { BASE_URL_M_ADMIN } from '../config';

let options = {};
let headers = new Headers();
const token = sessionStorage.getItem('token');

headers.append('content-type', 'application/json')
headers.append('Authorization', `${token}`);

options.headers = headers;
options.redirect = 'follow';

export async function getAllLicenceVersion() {
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/licenseversion`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function addLicenceVersion(body) {
    try {
        const response = await serviceContext.post(`${BASE_URL_M_ADMIN}madmin/licenseversion`, JSON.stringify(body), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function updateLicenceVersion(body) {
    try {
        const response = await serviceContext.put(`${BASE_URL_M_ADMIN}madmin/licenseversion`, JSON.stringify(body), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function getVersionListByDeviceList(body) {
    try {
        const response = await serviceContext.post(`${BASE_URL_M_ADMIN}madmin/licenseversion/getbydevice`, JSON.stringify(body), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function deleteLicenceVersion(body) {
    try {
        const response = await serviceContext.del(`${BASE_URL_M_ADMIN}madmin/licenseversion`, JSON.stringify(body), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}